const PATTERN = /^([0-9]{0,7}(?:\.\d{0,3})?)(?:\s?[Mm]\s?([0-9]{0,9}(?:\.\d{0,3})?))?$/;

export function validateMoneyAmount(s: string, allowEmpty = false): string | null {
  if (s === "M" || s === "m") {
    return "";
  }
  if (allowEmpty && s === "") {
    return s;
  }
  const pass = PATTERN.test(s);
  const containsM = s.includes("M");
  const contains_m = s.includes("m");
  const [left, right] = s.split(containsM ? "M" : "m");
  const [decimal, fraction] = left.split(".");
  const fixed = decimal + (right || "") + (fraction ? "." + fraction : "") + (containsM || contains_m ? "M" : "");
  return PATTERN.test(fixed) ? convertToMoneyAmount(parseMoneyAmount(fixed), true) : null;
}

export function parseMoneyAmount(value: string): number | string {
  if (value === "") {
    return value;
  }
  if (!PATTERN.test(value)) {
    return value;
  }
  const numericPart = value.replace(/[Mm]/, "").trim();
  let amount = parseFloat(numericPart);
  if (/[Mm]/.test(value)) {
    amount *= 1_000_000;
  }
  if (numericPart.endsWith(".")) {
    return amount.toString() + ".";
  }
  return amount;
}

export function convertToMoneyAmount(value: number | string, removeDot = true): string {
  const mvalue = +value;
  if (isNaN(mvalue)) return value.toString();
  if (mvalue < 1_000_000) return value.toString();
  let str = (mvalue / 1_000_000).toFixed(3);
  if (str.includes(".")) {
    str = str.replace(/0+$/, "");
    if (removeDot && str.endsWith(".")) {
      str = str.slice(0, -1);
    }
  }
  return str + "M";
}
